import { CampaignChannelsMeta, CampaignChannelsMetaMap, getCampaignsChannels } from '@/pages/campaign-builder/campaign.builder.utils';
import { CampaignChannelType, CampaignsType } from '@/types';
import { Flex, Icon, IconType, Tooltip, TooltipContent, TooltipTrigger, Typography } from '@alpine-iq/ui-library';
import React from 'react';

const iconsAndColorsByType: Record<CampaignChannelType, IconType> = {
	adTemplate: 'MARKETING',
	emailTemplate: 'EMAIL_NEW',
	pushTemplate: 'MOBILE',
	browserTemplate: 'BROWSER',
	templates: 'CHAT_BUBBLE',
	snailMailTemplate: 'MAIL',
	voiceTemplate: 'TELEPHONE',
};

export default function CampaignChannelIcon({ channel }: { channel: CampaignChannelType }) {
	const color = 'var(--info)';
	const background = 'var(--blue100)';

	const channelInfo = CampaignChannelsMetaMap[channel];

	return (
		<>
			<Tooltip>
				<TooltipTrigger asChild>
					<Flex
						center
						style={{ height: 32, width: 32, borderRadius: '50%', backgroundColor: background }}
					>
						<Icon
							type={iconsAndColorsByType?.[channel]}
							color={color}
							height={20}
							width={20}
						/>
					</Flex>
				</TooltipTrigger>
				<TooltipContent>
					<>{channelInfo?.shortName}</>
				</TooltipContent>
			</Tooltip>
		</>
	);
}

export function CampaignChannelIcons({ campaign, channelsIota }: { campaign: CampaignsType; channelsIota?: number[] }) {
	const channelIcons = React.useMemo(() => {
		if ((channelsIota?.length ?? 0) > 0) {
			const iotaToChannelType = CampaignChannelsMeta.reduce(
				(acc, type) => {
					const meta = CampaignChannelsMetaMap[type];
					if (meta) {
						acc[meta.iota] = type;
					}
					return acc;
				},
				{} as Record<number, CampaignChannelType>,
			);

			return (
				channelsIota?.map((iota) => (
					<CampaignChannelIcon
						key={iota}
						channel={iotaToChannelType[iota]}
					/>
				)) ?? []
			);
		}

		return getCampaignsChannels(campaign, true).map(([channel, _]) => (
			<CampaignChannelIcon
				key={channel}
				channel={channel}
			/>
		));
	}, [campaign]);

	return (
		<Flex
			align="center"
			gap={8}
		>
			{channelIcons}
		</Flex>
	);
}
